// Module to hold functions to assist working with categories

/**
 * Returns an array of category objects from the root to the specified category
 * @param {string} catId the category id as the starting point to find the path to the root.
 * @param {Map} allCategories a map containing all category objects.
 * @returns {array} an array of category objects. the first is the root.
 */
const getCategoryTree = (catId, allCategories) => {
	if (catId === null || allCategories.size === 0) {
		return [];
	}
	const catTree = [];
	let categoryId = parseInt(catId, 10);
	let foundRootCategory = false;
	do {
		// Ran into an issue with unpublished categories that would return undefined
		// when executing allCategories.get(categoryId)
		if (categoryId === 0 || allCategories.get(categoryId) == null) {
			foundRootCategory = true;
			catTree.push({
				name: 'Categories',
				categoryId: '',
			});
		} else {
			catTree.push(allCategories.get(categoryId));
			categoryId = allCategories.get(categoryId).parentId;
		}
	} while (!foundRootCategory);
	return catTree.reverse();
};

/**
 * Returns all the children categories of the category id passed in
 * @param {string} catID the category id as the starting point to find the path to the root.
 * @param {Map} allCategories an map containing all category objects.
 * @returns {array} an array of category objects. the first is the root.
 */
const getCategoryChildren = (catID, allCategories) => {
	const catChildren = [];
	if (catID != null && allCategories.size > 0) {
		const formatId = parseInt(catID, 10);
		allCategories.forEach(currentCat => {
			if (currentCat.parentId === formatId) {
				catChildren.push({
					categoryId: currentCat.categoryId,
					name: currentCat.name,
					url: currentCat.pictureUrl,
				});
			}
		});
	}
	return catChildren;
};

/**
 * Returns the parent id of the category passed in
 * @param {string} catID the category id as the starting point to find the path to the root.
 * @param {Map} allCategories an map containing all category objects.
 * @returns {string} of the category parent id
 */
const getCategoryParentId = (catID, allCategories) => {
	let catParent = null;
	if (catID != null && allCategories.size > 0) {
		const formatId = parseInt(catID, 10);
		if (allCategories.has(formatId)) {
			catParent = allCategories.get(formatId).parentId;
		}
	}
	return catParent;
};

exports = { getCategoryTree, getCategoryChildren, getCategoryParentId };

module.exports = {
	getCategoryTree,
	getCategoryChildren,
	getCategoryParentId,
};
